<template>
  <div>
    <ubi-panel v-loading="loadingStatus">
      <ubi-list-header slot="header"
                      :limits="limits"
                      :total="total"
                      :page.sync="currentPage"
                      :limit.sync="currentLimit"
                      :hyper-espace-display="true"></ubi-list-header>
      <el-table ref="table"
                v-if="total > 0"
                :data="list"
                :row-style="{ height: '145px' }"
                :cell-style="{ padding: '10px' }"
      >
      <el-table-column :label="$t('socialPosts.models.modelSummary')" width="200" class="fixed-height">
          <template v-slot="{ row: result }">
                <el-image v-if="result.photos && result.photos[0]" :src="result.photos[0].url" fit="contain" style="max-height: 130px;"/>
          </template>
        </el-table-column>
        <el-table-column label="" width="auto">
          <template v-slot="{ row: result }">
            <div class="cell-content">
              <p style="margin-top: 0;margin-right: 10px;overflow: hidden;text-overflow: ellipsis;word-wrap: break-word;word-break: break-word;text-align: justify;"><strong>{{ result.titre }}</strong></p>
              <p style="margin-right: 15px;margin-bottom: 10px;overflow: hidden;text-overflow: ellipsis;word-wrap: break-word;word-break: break-word;text-align: justify;">{{ rognerTexte(result.texte) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('socialPosts.models.for')" width="180">
          <template v-slot="{ row: result }">
            <img :src="require('@/assets/facebook-logo-5-1.png')" v-if="result.donnees.facebook_caption" width="20" style="margin-right: 10px;">
            <img :src="require('@/assets/2048px-Instagram_icon.png')" v-if="result.donnees.instagram_caption" width="20" style="margin-right: 10px;">
            <img :src="require('@/assets/linkedin-logo.png')" v-if="result.donnees.linkedin_commentary" width="20" style="margin-right: 10px;">
            <img :src="require('@/assets/google-logo-carre.png')" v-if="result.donnees.google_localpost_summary" width="20" style="margin-right: 10px;">
          </template>
        </el-table-column>
        <el-table-column :label="$t('socialPosts.models.actions')" width="170">
            <template v-slot="{ row: result }">
              <el-button size="mini" type="primary" style="margin-right: 10px;" @click="useModel(result)">{{ $t('socialPosts.models.use') }}</el-button>
              <em class="el-icon-edit-outline" style="margin-right: 10px;font-weight: 400;" @click="edit(result.id)" v-if="showEditDelete"></em>
              <em class="el-icon-delete" style="font-weight: 400;" @click="openModalDelete(result.id)" v-if="showEditDelete"></em>
            </template>
        </el-table-column>
      </el-table>
      <ubi-list-footer
          slot="footer"
          :limits="limits"
          :total="total"
          :page.sync="currentPage"
          :limit.sync="currentLimit"
      ></ubi-list-footer>
    </ubi-panel>
  </div>
</template>

<script>
import UbiPanel from '@/components/Panel.vue'
import UbiListHeader from '@/components/lists/ListHeader.vue'
import UbiListFooter from '@/components/lists/ListFooter.vue'

export default {
  name: 'ModelsTable',
  components: {
    UbiPanel,
    UbiListHeader,
    UbiListFooter
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      required: true
    },
    loadingStatus: {
      type: Boolean,
      default: false
    },
    showEditDelete: {
      type: Boolean,
      default: true
    },
    limits: {
      type: Array,
      default: () => [5, 10, 20]
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(value) {
        this.$emit('update:page', value)
      }
    },
    currentLimit: {
      get() {
        return this.limit
      },
      set(value) {
        this.$emit('update:limit', value)
      }
    }
  },
  methods: {
    rognerTexte(texte) {
      return texte.length > 200 ? texte.substring(0, 200) + '...' : texte.substring(0, 200);
    },
    fromCockpit(reference) {
      return reference.substring(0, 6) === 'CCKPT_';
    },
    edit(id) {
      this.$emit('edit', id);
    },
    useModel(id) {
      this.$emit('use', id);
    },
    openModalDelete(id) {
      this.$emit('delete', id);
    }
  }
}
</script>

<style scoped>
em.el-icon-delete:hover {
  color: #d24554 !important;
  font-weight: bold;
  cursor: pointer;
}
em.el-icon-edit-outline:hover {
  color: #d24554 !important;
  font-weight: bold;
  cursor: pointer;
}
.fixed-height {
    height: 300px; /* Hauteur fixe de 50px */
    //line-height: 50px; /* Aligner le texte verticalement */
    overflow: hidden; /* Empêche le débordement si le texte est trop long */
}
.cell-content {
display: inline-block;
text-align: left;
position: absolute;
top: 0;
padding: 10px 0;
}

/* Pour s'assurer que la cellule du tableau a une position relative */
.el-table .cell {
position: relative;
}
</style> 